import {
  FETCHING_STREAM, FETCHING_STREAM_SUCCEDDED, FETCHING_STREAM_FAILED, INVALIDATE_STREAM,
  FETCHING_STREAM_CHILDREN, FETCHING_STREAM_CHILDREN_SUCCEDDED, FETCHING_STREAM_CHILDREN_FAILED,
  FETCHING_STREAM_ANALYTICS_REQUEST, FETCHING_STREAM_ANALYTICS_SUCCEDDED, FETCHING_STREAM_ANALYTICS_FAILED,

  SUBSCRIBING_STREAM_REQUEST, SUBSCRIBING_STREAM_SUCCEDDED, SUBSCRIBING_STREAM_FAILED,
  UNSUBSCRIBING_STREAM_REQUEST, UNSUBSCRIBING_STREAM_SUCCEDDED, UNSUBSCRIBING_STREAM_FAILED,

  UPDATING_STREAM, UPDATING_STREAM_SUCCEDDED, UPDATING_STREAM_FAILED,
  DELETING_STREAM, DELETING_STREAM_SUCCEDDED, DELETING_STREAM_FAILED,

  CREATING_GROUP_SECTION, CREATING_GROUP_SECTION_SUCCEDDED, CREATING_GROUP_SECTION_FAILED,

  CREATING_GROUP, CREATING_GROUP_SUCCEDDED, CREATING_GROUP_FAILED,
  UPDATING_GROUP, UPDATING_GROUP_SUCCEDDED, UPDATING_GROUP_FAILED,
  DELETING_GROUP, DELETING_GROUP_SUCCEDDED, DELETING_GROUP_FAILED, INVALIDATE_CHILD_SELECTION,

  CREATING_GROUP_PARENT_GROUP_SUCCEDDED,
  ADD_ASSET_TO_STREAM, ADD_ASSET_TO_STREAM_SUCCEDDED, ADD_ASSET_TO_STREAM_FAILED, UPDATING_ASSET_SUCCEDDED,
  REMOVE_ASSET_FROM_STREAM, REMOVE_ASSET_FROM_STREAM_SUCCEDDED, REMOVE_ASSET_FROM_STREAM_FAILED,
  UPDATING_STREAM_ACCESS_SUCCEDDED,

  FETCHING_ASSET_ANALYTICS_REQUEST, FETCHING_ASSET_ANALYTICS_SUCCEDDED, FETCHING_ASSET_ANALYTICS_FAILED,
  SORT_STREAM_CHILDREN, TOGGLE_STREAM_LIST_VIEW, SORT_STREAM_CHILDREN_BY_TYPE
} from '../actions/actionTypes.jsx';

import { orderBy } from 'natural-orderby';

import _ from 'lodash';

const initialState = {
  sort: {
    type: "name",
    order: "ASC"
  },
  list_view: false
};

const streamState = {
  loading: false,
  invalidated: true,
  item: null,
  subscribing: false,
  updating: false,
  deleting: false,
  creatingGroup: false,
  updatingGroup: false,
  updatingAsset: false,
  creatingSection: false,
  loadingChildren: false,
  errors: null
};

const streamAnalyticsState = {
  loading: false,
  item: null
}

function sortChildrens(type, order, items) {
  var sortedSections = items.filter((item) => {
    return item.entityType === 'section';
  }).sort((a, b) => {
    return new Date(a.createdDate) - new Date(b.createdDate);
  });

  var sortedGroupItems = items.filter((item) => {
    return item.entityType === 'group';
  })

  var sortedGroup;

  if (type == "name") {
    sortedGroup = orderBy(
      sortedGroupItems,
      [asset => asset.name],
      [order == 'ASC' ? 'asc' : 'desc']
    )
  } else if (type == "modified_date") {
    sortedGroup = orderBy(
      sortedGroupItems,
      [asset => asset.modifiedDate],
      [order == 'ASC' ? 'asc' : 'desc']
    )
  } else {
    sortedGroup = orderBy(
      sortedGroupItems,
      [asset => asset.name],
      [order == 'asc']
    )
  }

  var sortedAsset = items.filter((item) => {
    return item.entityType === 'asset';
  })

  if (type != "name") {
    sortedAsset.sort((a, b) => {
      var analyticsA = a.analytics && a.analytics.item || {};
      var analyticsB = b.analytics && b.analytics.item || {};
      var modifiedDateA = a.metadata && a.metadata.modified_date || {};
      var modifiedDateB = b.metadata && b.metadata.modified_date || {};
      if (type == "Views") {
        var viewsA = analyticsA.views || 0;
        var viewsB = analyticsB.views || 0;

        if (order == "ASC") {
          return viewsA > viewsB ? 1 : viewsA < viewsB ? -1 : 0;
        } else {
          return viewsA < viewsB ? 1 : viewsA > viewsB ? -1 : 0;
        }
      } else if (type == "Shares") {
        var sharesA = analyticsA.shares || 0;
        var sharesB = analyticsB.shares || 0;

        if (order == "ASC") {
          return sharesA > sharesB ? 1 : sharesA < sharesB ? -1 : 0;
        } else {
          return sharesA < sharesB ? 1 : sharesA > sharesB ? -1 : 0;
        }
      } else if (type == "Downloads") {
        var downloadsA = analyticsA.downloads || 0;
        var downloadsB = analyticsB.downloads || 0;

        if (order == "ASC") {
          return downloadsA > downloadsB ? 1 : downloadsA < downloadsB ? -1 : 0;
        } else {
          return downloadsA < downloadsB ? 1 : downloadsA > downloadsB ? -1 : 0;
        }
      } else if (type == "TimeSpent") {
        var timeSpentA = analyticsA.avgTimeSpent || 0;
        var timeSpentB = analyticsB.avgTimeSpent || 0;

        if (order == "ASC") {
          return timeSpentA > timeSpentB ? 1 : timeSpentA < timeSpentB ? -1 : 0;
        } else {
          return timeSpentA < timeSpentB ? 1 : timeSpentA > timeSpentB ? -1 : 0;
        }
      }
      else if (type == "modified_date") {
        if (order == "ASC") {
          return modifiedDateA > modifiedDateB ? 1 : modifiedDateA < modifiedDateB ? -1 : 0;
        } else {
          return modifiedDateA < modifiedDateB ? 1 : modifiedDateA > modifiedDateB ? -1 : 0;
        }
      }
    });
  } else {
    sortedAsset = orderBy(
      sortedAsset,
      [asset => asset.name],
      [order == "ASC" ? 'asc' : 'desc']
    )
  }

  var sortedChildren = [...sortedSections, ...sortedGroup, ...sortedAsset];

  return sortedChildren;
}

function streamReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_STREAM:
      var id = action.payload;
      var stream = state[id] || streamState;

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          loading: true,
          invalidated: true
        }
      })
    case FETCHING_STREAM_SUCCEDDED:
      var id = action.payload.id;
      var stream = state[id] || streamState;

      var children = stream.item ? stream.item.children : [];

      var analytics = streamAnalyticsState;
      if (stream.item) {
        analytics = stream.item.analytics || analytics;
      }

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          loading: false,
          invalidated: false,
          item: {
            ...action.payload.stream,
            children: children,
            analytics: {
              ...analytics
            }
          }
        }
      })
    case FETCHING_STREAM_FAILED:
      var id = action.payload.id;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          loading: false,
          invalidated: false,
          item: null,
          errors: action.payload.error.errors
        }
      })
    case INVALIDATE_STREAM:
      var id = action.payload.id;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          loading: false,
          invalidated: true,
          item: null
        }
      })
    case FETCHING_STREAM_ANALYTICS_REQUEST:
      var id = action.payload;
      var stream = state[id] || streamState;

      if (stream.item == null) {
        return state;
      }

      var analytics = stream.item.analytics || streamAnalyticsState;

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          item: {
            ...stream.item,
            analytics: {
              ...analytics,
              loading: true
            }
          }
        }
      })
    case FETCHING_STREAM_ANALYTICS_SUCCEDDED:
      var id = action.payload.id;
      var stream = state[id] || streamState;

      if (stream.item == null) {
        return state;
      }

      var analytics = stream.item.analytics || streamAnalyticsState;

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          item: {
            ...stream.item,
            analytics: {
              ...analytics,
              loading: false,
              item: action.payload.analytics
            }
          }
        }
      })

    case FETCHING_STREAM_ANALYTICS_FAILED:
      var id = action.payload.id;
      var stream = state[id] || streamState;

      if (stream.item == null) {
        return state;
      }

      var analytics = stream.item.analytics || streamAnalyticsState;

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          item: {
            ...stream.item,
            analytics: {
              ...analytics,
              loading: false,
              error: action.payload.error
            }
          }
        }
      })
    case FETCHING_STREAM_CHILDREN:
      var id = action.payload;
      var stream = state[id] || streamState;

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          loadingChildren: true
        }
      })

    case FETCHING_STREAM_CHILDREN_SUCCEDDED:
      var id = action.payload.id;
      var stream = state[id] || streamState;

      var children = action.payload.children.records;
      var streamChildren = _.get(stream, "item.children") || [];

      var { currentPage, totalPages } = action.payload.children;

      if (currentPage != 0) {
        children = [...streamChildren, ...children];
      }

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          loadingChildren: false,
          item: {
            ...(stream.item || {}),
            children: children
          },
          currentPage: currentPage,
          totalPages: totalPages
        },
        sort: action.payload.sort,
      })

    case FETCHING_STREAM_CHILDREN_FAILED:
      var id = action.payload.id;
      var stream = state[id] || streamState;

      var children = _.get(stream, "item.children") || [];

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          loadingChildren: false
        }
      })

    case SUBSCRIBING_STREAM_REQUEST:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          subscribing: true
        }
      })
    case SUBSCRIBING_STREAM_SUCCEDDED:
      var id = action.payload.id;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          subscribing: false,
          item: {
            ...stream.item,
            followed: true,
            totalFollowers: stream.item.totalFollowers + 1
          }
        }
      })
    case SUBSCRIBING_STREAM_FAILED:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          subscribing: false
        }
      })


    case UNSUBSCRIBING_STREAM_REQUEST:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          subscribing: true
        }
      })
    case UNSUBSCRIBING_STREAM_SUCCEDDED:
      var id = action.payload.id;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          subscribing: false,
          item: {
            ...stream.item,
            followed: false,
            totalFollowers: Math.max(stream.item.totalFollowers - 1, 0)
          }
        }
      })
    case UNSUBSCRIBING_STREAM_FAILED:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          subscribing: false
        }
      })

    case UPDATING_STREAM:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: true
        }
      })
    case UPDATING_STREAM_SUCCEDDED:
      var id = action.payload.id;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: false,
          item: {
            ...stream.item,
            name: action.payload.stream.name,
            summary: action.payload.stream.summary,
            modifiedDate: action.payload.stream.modifiedDate,
            banner: action.payload.stream.banner
          }
        }
      })
    case UPDATING_STREAM_FAILED:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: false
        }
      })

    case DELETING_STREAM:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          deleting: true
        }
      })
    case DELETING_STREAM_SUCCEDDED:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          deleting: true,
          item: null
        }
      })
    case DELETING_STREAM_FAILED:
      var id = action.payload.id;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          deleting: false
        }
      })

    case CREATING_GROUP_SECTION:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          creatingSection: true,
        }
      })

    case CREATING_GROUP_SECTION_SUCCEDDED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;

      let section = {
        id: action.payload.group.id,
        name: action.payload.group.name,
        entityType: action.payload.group.entityType
      }

      var items = stream.item;
      var children = items.children.slice();
      children.splice(items.children.length, 0, section);
      var uniqueItems = new Set(children).toJSON();

      var sortType = state.sort ? state.sort.type : "Name";
      var sortOrder = state.sort ? state.sort.order : "ASC";
      var sortedChildren = sortChildrens(sortType, sortOrder, uniqueItems);

      items = Object.assign({}, items, {
        ...items,
        children: sortedChildren,
        sectionCount: items.sectionCount + 1
      })

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          creatingSection: false,
          item: items
        }
      })
    case CREATING_GROUP_FAILED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          creatingSection: false,
        }
      })


    case CREATING_GROUP:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          creatingGroup: true,
        }
      })
    case CREATING_GROUP_SUCCEDDED: {
      var id = action.payload.streamId;
      var stream = state[id] || streamState;

      let group = action.payload.group;

      var streamItem = stream.item;

      var children = _.get(streamItem, "children") || [];
      children = [...children, group];
      children = _.uniqBy(children, 'id');

      var sortType = state.sort ? state.sort.type : "Name";
      var sortOrder = state.sort ? state.sort.order : "ASC";
      var sortedChildren = sortChildrens(sortType, sortOrder, children);

      streamItem = {
        ...streamItem,
        children: sortedChildren,
        analytics: {
          ...streamItem.analytics,
          item: {
            ...streamItem.analytics.item,
            groupCount: streamItem.analytics.item.groupCount + 1
          }
        }
      }

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          creatingGroup: false,
          item: streamItem
        }
      })
    }

    case CREATING_GROUP_FAILED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          creatingGroup: false,
        }
      })

    case CREATING_GROUP_PARENT_GROUP_SUCCEDDED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      if (!stream.item) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          item: {
            ...stream.item,
            groupCount: stream.item.groupCount + 1
          }
        }
      })

    case UPDATING_GROUP:
      if (!action.payload.groupId) {
        return state;
      }
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updatingGroup: true,
        }
      })
    case UPDATING_GROUP_SUCCEDDED:
      if (!action.payload.group.id) {
        return state;
      }
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      if (!stream.item || !action.payload.group.id) {
        return state;
      }

      var updatedGroup = {
        id: action.payload.group.id,
        name: action.payload.group.name,
      }

      var groupId = action.payload.group.id;

      if (!stream.item) {
        return state;
      }

      var children = stream.item.children.map((child, index) => {
        if (child.id != groupId) {
          return child;
        }

        return {
          ...child,
          ...updatedGroup
        };
      })

      var sortType = state.sort ? state.sort.type : "Name";
      var sortOrder = state.sort ? state.sort.order : "ASC";
      var sortedChildren = sortChildrens(sortType, sortOrder, children);

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updatingGroup: false,
          item: {
            ...stream.item,
            children: sortedChildren
          }
        }
      })
    case UPDATING_GROUP_FAILED:
      if (!action.payload.group.id) {
        return state;
      }
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updatingGroup: false,
        }
      })

    case UPDATING_ASSET_SUCCEDDED:
      if (!action.payload.asset.id) {
        return state;
      }

      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      if (!stream.item || !action.payload.asset.id) {
        return state;
      }

      var updatedAsset = action.payload.asset;

      var assetId = action.payload.asset.id;

      if (!stream.item) {
        return state;
      }

      var children = stream.item.children.map((child, index) => {
        if (child.id != assetId) {
          return child;
        }

        return {
          ...updatedAsset
        };
      })

      var sortType = state.sort ? state.sort.type : "Name";
      var sortOrder = state.sort ? state.sort.order : "ASC";
      var sortedChildren = sortChildrens(sortType, sortOrder, children);

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updatingGroup: false,
          item: {
            ...stream.item,
            children: sortedChildren
          }
        }
      })

    case DELETING_GROUP:
      if (action.payload.groupId) {
        return state;
      }
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updatingGroup: true,
        }
      })
    case DELETING_GROUP_SUCCEDDED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      if (!stream.item) {
        return state;
      }

      if (action.payload.groupId != null) {
        return Object.assign({}, state, {
          ...state,
          [id]: {
            ...stream,
            updatingGroup: false,
            item: {
              ...stream.item,
              analytics: {
                ...stream.item.analytics,
                item: {
                  ...stream.item.analytics.item,
                  groupCount: Math.max(stream.item.analytics.item.groupCount - 1, 0),
                }
              }
            }
          }
        })
      }

      var groupCount = stream.item.groupCount;
      if (action.payload.group.entityType === "group") {
        groupCount = Math.max(stream.item.groupCount - 1, 0)
      }

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updatingGroup: false,
          item: {
            ...stream.item,
            children: stream.item.children.filter((group, index) => {
              return group.id != action.payload.group.id
            }),
            analytics: {
              ...stream.item.analytics,
              item: {
                ...stream.item.analytics.item,
                groupCount: Math.max(stream.item.analytics.item.groupCount - 1, 0)
              }
            }
          }
        }
      })
    case DELETING_GROUP_FAILED:
      if (action.payload.groupId) {
        return state;
      }
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updatingGroup: false,
        }
      })

    case ADD_ASSET_TO_STREAM:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: true,
        }
      })
    case ADD_ASSET_TO_STREAM_SUCCEDDED:
      {
        var id = action.payload.streamId;
        var stream = state[id] || streamState;

        let children = [...stream.item.children, ...action.payload.asset];
        uniqueItems = _.uniqBy(children, 'id');

        uniqueItems = uniqueItems.map((item) => {
          if (item.entityType === 'asset') {
            return {
              ...item,
              analytics: {
                item: null,
                loading: false
              }
            }
          }
          return item;
        });

        var sortType = state.sort ? state.sort.type : "Name";
        var sortOrder = state.sort ? state.sort.order : "ASC";
        var sortedChildren = sortChildrens(sortType, sortOrder, uniqueItems);

        return Object.assign({}, state, {
          ...state,
          [id]: {
            ...stream,
            updating: false,
            item: {
              ...stream.item,
              children: sortedChildren,
            }
          }
        })
      }
    case ADD_ASSET_TO_STREAM_FAILED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: false,
        }
      })

    case REMOVE_ASSET_FROM_STREAM:
      var id = action.payload;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: true,
        }
      })
    case REMOVE_ASSET_FROM_STREAM_SUCCEDDED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;

      let assetIds = action.payload.asset.map((item) => {
        return item.id;
      })

      let childrens = stream.item.children.filter(asset => !assetIds.includes(asset.id));

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: false,
          item: {
            ...stream.item,
            children: childrens,
            analytics: {
              ...stream.item.analytics,
              item: {
                ...stream.item.analytics.item,
                assetCount: stream.item.analytics.item.assetCount - action.payload.asset.length,
              }
            }
          }
        }
      })
    case REMOVE_ASSET_FROM_STREAM_FAILED:
      var id = action.payload.streamId;
      var stream = state[id] || streamState;
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          updating: false,
        }
      })

    case UPDATING_STREAM_ACCESS_SUCCEDDED:
      var id = action.payload.id;
      var stream = state[id];
      if (!stream) {
        return state
      }
      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...stream,
          item: {
            ...stream.item,
            readAll: action.payload.readAll,
            writeAll: action.payload.writeAll
          }
        }
      })

    case FETCHING_ASSET_ANALYTICS_REQUEST:
      var assetId = action.payload.assetId;
      var streamId = action.payload.streamId;

      var stream = state[streamId];

      if (!stream) {
        return state;
      }

      var children = stream.item.children.map((child, index) => {
        if (child.id != assetId) {
          return child;
        }

        return {
          ...child,
          analytics: {
            loading: true,
            item: null
          }
        };
      })

      return Object.assign({}, state, {
        ...state,
        [streamId]: {
          ...stream,
          item: {
            ...stream.item,
            children: children
          }
        }
      })

    case FETCHING_ASSET_ANALYTICS_SUCCEDDED:
      var assetId = action.payload.context.assetId;
      var streamId = action.payload.context.streamId;

      var stream = state[streamId];

      if (!stream) {
        return state;
      }

      var children = stream.item.children.map((child, index) => {
        if (child.id != assetId) {
          return child;
        }

        return {
          ...child,
          analytics: {
            loading: false,
            item: action.payload.response
          }
        };
      })

      return Object.assign({}, state, {
        ...state,
        [streamId]: {
          ...stream,
          item: {
            ...stream.item,
            children: children
          }
        }
      })

    case FETCHING_ASSET_ANALYTICS_FAILED:
      var assetId = action.payload.context.assetId;
      var streamId = action.payload.context.streamId;

      var stream = state[streamId];

      if (!stream) {
        return state;
      }

      var children = stream.item.children.map((child, index) => {
        if (child.id != assetId) {
          return child;
        }

        return {
          ...child,
          analytics: {
            loading: false,
            item: null,
            error: action.payload.error
          }
        };
      })

      return Object.assign({}, state, {
        ...state,
        [streamId]: {
          ...stream,
          item: {
            ...stream.item,
            children: children
          }
        }
      })

    case TOGGLE_STREAM_LIST_VIEW:
      var list = action.payload.list;

      return Object.assign({}, state, {
        ...state,
        list_view: list
      })

    case SORT_STREAM_CHILDREN_BY_TYPE:
      var streamId = action.payload.streamId;
      var sort = action.payload.sort;

      var stream = state[streamId];

      if (!stream) {
        return Object.assign({}, state, {
          ...state,
          sort: sort
        })
      }

      var children = stream.item.children || [];
      var sortedChildren = sortChildrens(sort.type, sort.order, children);

      return Object.assign({}, state, {
        ...state,
        [streamId]: {
          ...stream,
          item: {
            ...stream.item,
            children: sortedChildren
          }
        },
        sort: sort
      })


    default:
      return state
  }
}

export { streamReducer };